<template>
  <div :key="show">
    <svg viewBox="-400 -400 800 800" :style="{width: width, height: height}">
      <circle :r="800 * 0.15" :style="{fill:'none', stroke:'#ddd', strokeWidth: 12}" />
      <circle :r="800 * 0.25" :style="{fill:'none', stroke:'#dedede', strokeWidth: 10.5}" />
      <circle :r="800 * 0.4" :style="{fill:'none', stroke:'#eeeeee', strokeWidth: 9}" />
      <PieChart
        v-for="(profile, index) in theData"
        :key="profile.noc"
        :style="{cursor: index == 0 ? '':'pointer'}"
        :profile="profile"
        :position="positions[index]"
        :radius="radii[index]"
        :toolbar="toolbar[index]" 
        @mousemove.native="onMouseMove(index, $event)"
        @mouseout.native="onMouseOut($event)"
        @click.native="onClick(index)"
        @close="onClose(profile.noc)"
      />
    </svg>
    <v-dialog v-model="dialog" max-width="600">
      <DetailsPanel :profile="theData[current]" @closeModal="dialog = false" />
    </v-dialog>
    <Tooltip v-show="tooltip" :profile="current ? theData[current] : theData[0]" :position="tooltipPosition" />
  </div>
</template>

<script>
import * as d3 from "d3";
import PieChart from "./PieChart";
import DetailsPanel from "./DetailsPanel";
import Tooltip from "./Tooltip";

export default {
  name: "BubbleChart",
  data() {
    return {
      current: null,
      positions: this.getLocations(800),
      toolbar: [],
      radii: [],
      dialog: false,
      tooltip: false,
      tooltipPosition: {},
      show: 1
    };
  },
  props: {
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "auto"
    }
  },
  computed: {
    userProfile() {
      this.show++;
      return this.$store.getters.getUserProfile;
    },
    theData() {
      return [
        this.userProfile,
        ...this.$store.getters.getTopList(this.userProfile, 20, 1)
      ];
    }
  },
  watch: {
    current(newVal, oldVal) {
      if (oldVal) {
        this.toolbar[oldVal] = false;
        this.radii[oldVal] = this.getRadius(oldVal);
      }
      if (newVal) {
        this.toolbar[newVal] = true;
        this.radii[newVal] = this.getRadius(newVal) * 1.1;
      }
    }
  },
  created() {
    for (let i = 0; i < 21; i++) {
      this.radii.push(this.getRadius(i));
      this.toolbar.push(false);
    }
  },
  mounted() {},
  methods: {
    getRadius(index) {
      switch (true) {
        case index == 0:
          return 60;
        case index <= 6:
          return 55;
        default:
          return 50;
      }
    },
    getLocations(svgSide = 800) {
      const radii = [svgSide * 0.15, svgSide * 0.25, svgSide * 0.4];
      const trigMagicNumbers = [
        1.0,
        3.0,
        5.0,
        7.0,
        9.0,
        11.0,
        0.0,
        2.0,
        4.0,
        6.0,
        8.0,
        10.0,
        0,
        2,
        4,
        6,
        8,
        10,
        12,
        14
      ];
      let loc = [
        {
          x: 0,
          y: 0
        }
      ];
      for (let i in trigMagicNumbers) {
        if (i < 6) {
          loc.push({
            x: radii[0] * Math.cos((Math.PI * trigMagicNumbers[i]) / 6.0),
            y: radii[0] * Math.sin((Math.PI * trigMagicNumbers[i]) / 6.0)
          });
        } else if (i < 12) {
          loc.push({
            x: radii[1] * Math.cos((Math.PI * trigMagicNumbers[i]) / 6.0),
            y: radii[1] * Math.sin((Math.PI * trigMagicNumbers[i]) / 6.0)
          });
        } else {
          loc.push({
            x: radii[2] * Math.cos((Math.PI * trigMagicNumbers[i]) / 8.0),
            y: radii[2] * Math.sin((Math.PI * trigMagicNumbers[i]) / 8.0)
          });
        }
      }
      return loc;
    },
    onMouseMove(index, event) {
      if (index != 0) {
        this.current = index;
        this.tooltipPosition = { x: event.x + 20, y: event.y + 5 };
        this.tooltip = true;
      }
    },
    onMouseOut(event) {
      this.tooltipPosition = { x: event.x + 20, y: event.y + 5 };
      this.tooltip = false;
    },
    onClose(noc) {
      this.$store.dispatch("addExclusion", noc);
    },
    onClick(index) {
      if (index != 0) this.dialog = true;
    }
  },
  components: {
    PieChart,
    DetailsPanel,
    Tooltip
  }
};
</script>

<style scoped>
svg {
  background-color: white;
}

@media screen and (min-width: 1264px) {
  svg {
    height: 1113px;
    width: 1113px;
  }
}
@media screen and (min-width: 960px) and (max-width: 1263px) {
  svg {
    height: 828px;
    width: 828px;
  }
}
@media screen and (max-width: 959px) {
  svg {
    height: calc(100vw - 96px);
    width: calc(100vw - 96px);
  }
}
</style>